import { useEffect, useState } from 'react';
import { listMovies, type MovieListItem } from '../api/library';
import { LibraryGrid } from '../components/LibraryGrid';

export function Movies() {
  const [movies, setMovies] = useState<MovieListItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    listMovies()
      .then((res) => { if (!cancelled) setMovies(res.items); })
      .catch((err) => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; };
  }, []);

  if (error) return <div className="text-red-600">{error}</div>;
  if (!movies) return <div className="text-text-secondary">Loading…</div>;

  return (
    <div>
      <h1 className="mb-4 text-2xl font-semibold">Movies</h1>
      <LibraryGrid items={movies} />
    </div>
  );
}
